import styled from 'styled-components';

interface MarginProp {
  height?: number;
  width?: number;
}

export const Margin = styled.div<MarginProp>`
  height: ${({ height }) => (height && `${height}px`) || '1px'};
  width: ${({ width }) => (width && `${width}px`) || '100%'};
`;
